import { createSvgIcon } from '@mui/material/utils'

const SuccessForkKnife = createSvgIcon(
  <>
    <path
      d="M52.9 31.25C57.4 24.7 62.01 21.66 65.85 21.66C67.44 21.66 68.88 22.38 70.18 23.81C71.48 25.24 72.13 26.85 72.13 28.64C72.13 33.45 66.93 36.92 56.54 37.81V38.51C61.7 38.94 65.58 40.24 68.2 41.67C70.82 43.1 72.13 45.02 72.13 47.43C72.13 49.17 71.5 50.77 70.24 52.23C68.98 53.68 67.52 54.41 65.85 54.41C61.93 54.41 57.38 51.33 52.96 44.74L52.27 45.14C54.48 49.64 55.14 53.69 55.14 56.79C55.14 61.6 52.95 64 48.57 64C46.48 64 44.85 63.36 43.68 62.08C42.56 60.72 41.99 59.02 41.99 56.96C41.99 53.86 42.67 49.75 44.88 45.14L44.17 44.73C39.75 51.32 35.2 54.4 31.29 54.4C29.7 54.4 28.26 53.71 26.96 52.34C25.66 50.97 25.01 49.33 25.01 47.43C25.01 42.62 30.19 39.34 40.54 38.45V37.58C30.19 36.73 25.01 33.49 25.01 28.64C25.01 26.93 25.63 25.34 26.87 23.87C28.11 22.4 29.58 21.66 31.29 21.66C35.13 21.66 39.69 24.72 44.19 31.28L44.8 30.95C42.59 26.41 41.99 22.26 41.99 19.04C41.99 16.98 42.55 15.28 43.68 13.92C44.84 12.64 46.47 12 48.57 12C52.95 12 55.14 14.38 55.14 19.15C55.14 22.29 54.47 26.37 52.26 30.9L52.89 31.24L52.9 31.25Z"
      stroke="#204ECF"
      strokeMiterlimit="10"
    />
    <path
      d="M85.05 70.06V12.08C87.7 12.49 89.5 16.19 89.5 20.27V47.14H85.05"
      stroke="#204ECF"
      strokeLinejoin="round"
    />
    <path
      d="M14.09 14.06L13.46 30.83L9.36002 34.7L9.75002 69.58H4.40002"
      stroke="#204ECF"
      strokeLinejoin="round"
    />
    <path d="M0.5 14.06L1.13 30.83L5.23 34.7L4.4 69.58" stroke="#204ECF" strokeLinejoin="round" />
    <path d="M9.35999 14.06V27.68" stroke="#204ECF" strokeLinejoin="round" />
    <path d="M5.22998 14.06V27.68" stroke="#204ECF" strokeLinejoin="round" />
    <path d="M32.03 14.06L21.91 3.73999" stroke="#204ECF" strokeMiterlimit="10" />
    <path d="M63.92 14.06L74.04 3.73999" stroke="#204ECF" strokeMiterlimit="10" />
    <path d="M63.92 62L74.04 71.8" stroke="#204ECF" strokeMiterlimit="10" />
    <path d="M32.03 62L21.91 71.8" stroke="#204ECF" strokeMiterlimit="10" />
    <path d="M48.57 6.1V0" stroke="#204ECF" strokeMiterlimit="10" />
    <path d="M48.57 76V69.58" stroke="#204ECF" strokeMiterlimit="10" />
  </>,
  'SuccessForkKnife'
)

export default SuccessForkKnife
